// Fix tee in blue select
let selectedSize = "30x20 cm"; // Default size

// Function to log events
function logEvent(message) {
  console.log(`[Size Selection]: ${message}`);
}

// Function to handle size selection
function handleSizeSelection(event) {
  selectedSize = event.target.value;
  logEvent(`Size selected: ${selectedSize}`);
}

// Function to select size after format change
function selectSize(size) {
  const sizeInputs = document.querySelectorAll(
    '.tee-option--size input[type="radio"]'
  );
  logEvent(`Attempting to select size: ${size}`);

  sizeInputs.forEach((input) => {
    if (input.value === size) {
      // Simulate click instead of just setting checked
      input.click();
      logEvent(`Successfully clicked size: ${size}`);
    }
  });
}

// Function to handle format changes
function handleFormatChange() {
  logEvent("Format changed");

  // Wait for DOM to update
  setTimeout(() => {
    selectSize(selectedSize);
  }, 100);
}

// Function to initialize event listeners
function initializeEventListeners() {
  logEvent("Initializing event listeners");

  // Listen for format changes
  document.addEventListener("change", (event) => {
    if (event.target.name === "availableProduct") {
      handleFormatChange();
    }
  });

  // Listen for size changes
  document.addEventListener("change", (event) => {
    if (event.target.name.startsWith("size-")) {
      handleSizeSelection(event);
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeEventListeners);
} else {
  initializeEventListeners();
}

// Optional: Monitor DOM changes for dynamically added elements
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      logEvent("DOM changed - checking for new elements");
      selectSize(selectedSize);
    }
  });
});

/*observer.observe(document.body, {
  childList: true,
  subtree: true,
});*/


// Teeinblue preview loader (no spinner)
(function () {
  const PREVIEW_SELECTOR = '[data-tee-preview]';
  const MAX_ATTEMPTS = 8;
  const RETRY_DELAY = 1200; // ms

  const withCacheBuster = (url, attempt) =>
    `${url}${url.includes('?') ? '&' : '?'}preview=${attempt}-${Date.now()}`;

  const stripResponsiveAttrs = (img) => {
    if (img.dataset.teeResponsiveStripped === 'true') return;

    ['srcset', 'sizes', 'data-widths', 'data-sizes', 'data-src'].forEach((attr) => {
      if (!img.hasAttribute(attr)) return;

      const dataKey = `teeOriginal${attr.replace(/(^[a-z])|(-[a-z])/g, (match) =>
        match.replace('-', '').toUpperCase()
      )}`;

      img.dataset[dataKey] = img.getAttribute(attr);
      img.removeAttribute(attr);
    });

    img.dataset.teeResponsiveStripped = 'true';
  };

  const finish = (img) => {
    img.classList.remove('tee-preview-loading');
    img.dataset.previewState = 'ready';
  };

  const alreadyHasPreview = (img) => {
    const previewUrl = img.dataset.teePreview;
    if (!previewUrl) return true;

    if (img.dataset.previewState === 'ready') return true;
    if (img.dataset.teePreviewLoaded === 'true') return true;

    const current = (img.currentSrc || img.src || '').split('?')[0];
    if (current && current.includes(previewUrl)) {
      img.dataset.teePreviewLoaded = 'true';
      img.dataset.previewState = 'ready';
      return true;
    }

    return false;
  };

  const pollPreview = (img, attempt = 0) => {
    const previewUrl = img.dataset.teePreview;
    if (!previewUrl) {
      finish(img);
      return;
    }

    // stop if we’re no longer loading
    if (img.dataset.previewState !== 'loading') return;
    if (attempt >= MAX_ATTEMPTS) {
      finish(img);
      return;
    }

    stripResponsiveAttrs(img);

    const tester = new Image();
    const src = withCacheBuster(previewUrl, attempt);

    tester.onload = () => {
      img.src = src;
      img.dataset.teePreviewLoaded = 'true';
      finish(img);
    };

    tester.onerror = () => {
      const nextAttempt = attempt + 1;
      setTimeout(() => pollPreview(img, nextAttempt), RETRY_DELAY);
    };

    tester.src = src;
  };

  const hydrateOne = (img) => {
    if (!img || img.dataset.previewInit === 'true') return;
    img.dataset.previewInit = 'true';

    if (!img.dataset.teePreview || alreadyHasPreview(img)) {
      finish(img);
      return;
    }

    img.dataset.previewState = 'loading';
    img.classList.add('tee-preview-loading');
    pollPreview(img, 0);
  };

  const hydrate = (root = document) => {
    if (root.matches?.(PREVIEW_SELECTOR)) hydrateOne(root);
    root.querySelectorAll?.(PREVIEW_SELECTOR).forEach(hydrateOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrate());
  } else {
    hydrate();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) hydrate(node);
      });
    });
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();


// Safely add enterkeyhint="enter" to dynamic inputs
(function () {
  const selector = '.tee-scrabble-wrapper .tee__input';

  function applyHint(el) {
    if (!el || el.nodeType !== 1) return; // 1 = ELEMENT_NODE
    if (!el.hasAttribute('enterkeyhint')) el.setAttribute('enterkeyhint', 'enter');
  }

  function scan(root) {
    if (!root) return;
    if (root.matches?.(selector)) applyHint(root);
    root.querySelectorAll?.(selector).forEach(applyHint);
  }

  function start(target) {
    // Initial pass
    scan(document);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          scan(node);
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  // Ensure we have a Node to observe
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () =>
      start(document.body || document.documentElement)
    );
  } else {
    start(document.body || document.documentElement);
  }
})();



/*document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const container = document.querySelector(".tee-photo-action");

    if (container && !container.querySelector(".giftcard-hint")) {
      const hint = document.createElement("div");
      hint.className = "giftcard-hint";
      hint.innerHTML = `
        <strong>Pas de photos ?</strong>
        <a href="/products/carte-cadeau-mistergift">Offrez une carte cadeau →</a>
        <br>
      `;

      container.appendChild(hint);
      observer.disconnect(); // stop once added
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});*/



(function() {
    // 1. CONFIGURATION: Set your images here
    const variantConfig =  {}/*{
        "Poster senza cornice": "https://link-to-your-photo.com/poster.jpg",
        "Cornice in legno": "https://link-to-your-photo.com/wood-frame.jpg",
        "Cornice nera": "https://link-to-your-photo.com/black-frame.jpg",
        "A4 21x30 cm": "https://link-to-your-photo.com/a4.jpg"
    };*/

    const observer = new MutationObserver((mutations) => {
        // Target the end of the input fields container
        const formInputs = document.querySelector('#teeFormInputs');
        const originalTeeVariants = document.querySelector('.tee-variants');

        // Only run if the form exists and our custom selector hasn't been added yet
        if (formInputs && originalTeeVariants && !document.querySelector('.custom-bottom-selector')) {
            renderBottomSelector(originalTeeVariants, formInputs);
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function renderBottomSelector(originalContainer, targetContainer) {
        const wrapper = document.createElement('div');
        // Added 'tee-field' class to maintain spacing consistency with other form fields
        wrapper.className = 'tee-block tee-field tee-variants tee-variants--outline tee-variants--rounded custom-bottom-selector';
        wrapper.style.marginTop = "20px"; // Visual separation from text fields

        const optionGroups = originalContainer.querySelectorAll('.tee-option');

        optionGroups.forEach((group) => {
            const clonedGroup = group.cloneNode(true);
            const clonedRadios = clonedGroup.querySelectorAll('.tee-radio');
            
            clonedRadios.forEach((clonedRadio, index) => {
                const input = clonedRadio.querySelector('input');
                const label = clonedRadio.querySelector('label');
                const variantText = input.value;

                const newId = 'bottom-' + input.id;
                input.id = newId;
                label.setAttribute('for', newId);
                input.name = input.name + '-bottom';

                if (variantConfig[variantText]) {
                    const img = document.createElement('img');
                    img.src = variantConfig[variantText];
                    img.className = 'custom-variant-img';
                    img.style.cssText = "display:block; width:100%; max-width:80px; margin: 0 auto 8px; border-radius:4px;";
                    
                    label.prepend(img);
                    label.style.display = "flex";
                    label.style.flexDirection = "column";
                    label.style.height = "auto";
                    label.style.padding = "10px";
                }

                clonedRadio.addEventListener('click', (e) => {
                    e.preventDefault();
                    const originalInputs = group.querySelectorAll('input');
                    if (originalInputs[index]) {
                        originalInputs[index].click(); 
                        
                        clonedRadios.forEach(r => r.classList.remove('active'));
                        clonedRadio.classList.add('active');
                    }
                });
            });

            wrapper.appendChild(clonedGroup);
        });

        // Append to the end of the form inputs container
        targetContainer.appendChild(wrapper);

        // --- GLOBAL SYNC ---
        originalContainer.addEventListener('click', () => {
            setTimeout(() => {
                const originalRadios = originalContainer.querySelectorAll('.tee-radio');
                const bottomRadios = wrapper.querySelectorAll('.tee-radio');
                originalRadios.forEach((r, i) => {
                    if (r.classList.contains('active')) {
                        bottomRadios[i].classList.add('active');
                    } else {
                        bottomRadios[i].classList.remove('active');
                    }
                });
            }, 50);
        });
    }
})();